// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { z } from 'zod';
import { ALL_REQUEST_TYPES } from '../constants/request-types.js';
/**
 * Validation schema for public intake form submission.
 * See: docs/product/phases/phase-1/sprint-1.0.0.md - Epic A
 */
export const publicIntakeSchema = z.object({
    request_type: z.enum(ALL_REQUEST_TYPES),
    requester_name: z.string().min(1, 'Full name is required').max(200),
    requester_email: z.string().email('Valid email is required').max(254),
    requester_phone: z.string().max(20).nullable().optional(),
    description: z.string().min(1, 'Description is required').max(5000),
    preferred_language: z.string().min(2).max(5).default('en'),
    consent_to_processing: z.literal(true, {
        errorMap: () => ({ message: 'Consent to processing is required' }),
    }),
});
/**
 * Validation schema for admin manual case creation.
 * See: docs/product/phases/phase-1/sprint-1.0.0.md - Epic D.2
 */
export const adminCreateCaseSchema = z.object({
    request_type: z.enum(ALL_REQUEST_TYPES),
    requester_name: z.string().min(1).max(200),
    requester_email: z.string().email().max(254),
    requester_phone: z.string().max(20).nullable().optional(),
    requester_id_type: z.string().max(50).nullable().optional(),
    requester_id_value: z.string().max(200).nullable().optional(),
    business_unit_id: z.string().nullable().optional(),
    description: z.string().max(10000).nullable().optional(),
    metadata: z.record(z.unknown()).optional(),
});
//# sourceMappingURL=intake.js.map